import { API_AUTH } from "./common";

const TatToanChoDuyetApi = {
    suDungTatToanChoDuyet: () =>
        API_AUTH.get(
            `tat-toan-cho-duyet/su-dung-tat-toan-cho-duyet`,
            {}
        ),

    kiemTraHopDongChoVayTatToanChoDuyet: (chovayId) =>
        API_AUTH.get(
            `tat-toan-cho-duyet/kiem-tra-hop-dong-cho-vay-tat-toan-cho-duyet?chovayId=${chovayId}`,
            {}
        ),

    danhSachTatToanChoDuyet: ({
        customerName,
        status,
        pageIndex,
        pageSize,
    }) => {
        return API_AUTH.get(
            `bao-cao/danh-sach-tat-toan-cho-duyet?customerName=${customerName}&status=${status}&pageIndex=${pageIndex}&pageSize=${pageSize}`,
            {}
        );
    },

    duyetTatToan: ({
        TatToanChoDuyetID,
        GhiChu,
        BuocDuyet,
        NguoiDuyet,
        TrangThai
    }) => {
        return API_AUTH.post(
            `tat-toan-cho-duyet/duyet-tat-toan`,
            { TatToanChoDuyetID, GhiChu, BuocDuyet, NguoiDuyet, TrangThai }
        );
    },

    tatToanNgay: ({
        TatToanChoDuyetID,
        GhiChu,
        BuocDuyet,
        NguoiDuyet,
        TrangThai
    }) => {
        return API_AUTH.post(
            `tat-toan-cho-duyet/tat-toan-ngay`,
            { TatToanChoDuyetID, GhiChu, BuocDuyet, NguoiDuyet, TrangThai }
        );
    },



    khongduyetTatToan: ({
        TatToanChoDuyetID,
        GhiChu,
        BuocDuyet,
        NguoiDuyet,
        TrangThai
    }) => {
        return API_AUTH.post(
            `tat-toan-cho-duyet/khong-duyet-tat-toan`,
            { TatToanChoDuyetID, GhiChu, BuocDuyet, NguoiDuyet, TrangThai }
        );
    },

    lichSuDuyetTatToan: (id) =>
        API_AUTH.get(
            `tat-toan-cho-duyet/lich-su-duyet-tat-toan?id=${id}`,
            {}
        ),

    capNhatTatToan: ({
        TatToanChoDuyetID, NguoiThanhToan, NgayThanhToan, TienTatToan, PhiKhac, PhiKho, GhiChu
    }) => {
        return API_AUTH.post(
            `tat-toan-cho-duyet/cap-nhat-tat-toan`,
            { TatToanChoDuyetID, NguoiThanhToan, NgayThanhToan, TienTatToan, PhiKhac, PhiKho, GhiChu }
        );
    },

    xoaTatToanChoDuyet: (id) =>
        API_AUTH.post(
            `tat-toan-cho-duyet/xoa-tat-toan?tatToanChoDuyetID=${id}`,
            {}
        ),


    phanQuyenTatToanChoDuyet: () =>
        API_AUTH.get(
            `tat-toan-cho-duyet/phan-quyen-tat-toan-cho-duyet`,
            {}
        ),

    phanQuyenTatToanChoDuyetTheoChucNang: (taikhoan, loai, tatToanChoDuyetID) =>
        API_AUTH.get(
            `tat-toan-cho-duyet/phan-quyen-tat-toan-cho-duyet-theo-chuc-nang?taikhoan=${taikhoan}&loai=${loai}&tatToanChoDuyetID=${tatToanChoDuyetID}`,
            {}
        ),


};

export default TatToanChoDuyetApi;
